import api from './api';

// TODO: remove
export const url = 'validation/mobile';

export const validationMobileGet = async (): Promise<void> => {
  return await api.get(url, true);
};
